// extracted by mini-css-extract-plugin
export default {"leads":"MyLeads_leads__fUATm","maxline":"MyLeads_maxline__GoVAe"};